import { HANDLE_SHOW_LOCATION_MODAL } from "../constants";

const useLocationModal = (existCookie, currentInstance) => {
  const showModal = HANDLE_SHOW_LOCATION_MODAL(existCookie, currentInstance);

  return { showModal };
};

export default useLocationModal;
